//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------

//  -- Create interaction -------------
export const createimageGallery = (returnedPayload) => ({ type: ActionTypes.image_gallery.create_image_gallery, payload: returnedPayload });


export const deleteimageGallery = (returnedPayload) => ({ type: ActionTypes.image_gallery.delete_image_gallery, payload: returnedPayload });

export const listimageGallery = (returnedPayload) => ({ type: ActionTypes.image_gallery.list_image_gallery, payload: returnedPayload });

